import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-swicther',
  templateUrl: './language-swicther.component.html',
  styleUrls: ['./language-swicther.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwictherComponent implements OnInit {
  selectedLang: any;
  @Input() location;
  laguageList = [
    { lang: 'English', value: 'en' },
    { lang: 'Tamil', value: 'ta' },
  ];
  selectLanguage = new FormControl({ lang: 'English', value: 'en' });

  constructor(public translate: TranslateService) {
    this.selectedLang = JSON.parse(localStorage.getItem('lang')) || { lang: 'English', value: 'en' };
    this.translate.use(this.selectedLang.value);
  }

  ngOnInit() {}
  changeLang(lang) {
    this.translate.use(lang);
    this.selectedLang = lang === 'en' ? { lang: 'English', value: 'en' } : { lang: 'Bengali', value: 'bn' };
    localStorage.setItem('lang', JSON.stringify(this.selectedLang));
  }
}
